import { render, staticRenderFns } from "./EbkDicts.vue?vue&type=template&id=4cd5042d&scoped=true&"
import script from "./EbkDicts.vue?vue&type=script&lang=js&"
export * from "./EbkDicts.vue?vue&type=script&lang=js&"
import style0 from "./EbkDicts.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EbkDicts.vue?vue&type=style&index=1&id=4cd5042d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd5042d",
  null
  
)

export default component.exports